"use strict";

exports.__esModule = true;
exports.getWidgetInteractionProps = getWidgetInteractionProps;
/**
 * Get interaction / event handler properties for a widget.
 */
function getWidgetInteractionProps(_ref) {
  var onClick = _ref.onClick;
  return {
    onClick: onClick
  };
}